// 中煤能源多行情版本
import Overview from './overview.vue';

export const componentMap = {
	overview: Overview
};
